module.exports = __webpack_public_path__ + "static/assets/956d0acb35a87b99ea0dd6e03d508168.svg";